enum UserRole {
    ADMIN = 'ADMIN',
    USER = 'USER',
    COMMODORE = 'COMMODORE',
    ORGANIZER = 'ORGANIZER',
}

const roleHierarchy: { [key in UserRole]: UserRole[] } = {
    [UserRole.ADMIN]: [UserRole.ADMIN, UserRole.USER, UserRole.COMMODORE, UserRole.ORGANIZER],
    [UserRole.COMMODORE]: [UserRole.COMMODORE, UserRole.ORGANIZER, UserRole.USER],
    [UserRole.ORGANIZER]: [UserRole.ORGANIZER, UserRole.USER],
    [UserRole.USER]: [UserRole.USER],
};

const roleLabels: { [key in UserRole]: string } = {
    [UserRole.ADMIN]: 'Administrátor',
    [UserRole.USER]: 'Uživatel',
    [UserRole.COMMODORE]: 'Komodor',
    [UserRole.ORGANIZER]: 'Organizátor',
};

export default UserRole;
export {roleHierarchy, roleLabels};